export default "__VITE_ASSET__Dt1SQ9E5__"